<!--
  Navigation bar
-->

<template lang="html">
  <nav id="top">
    <div class="container">
      <div class="row nav-top-row">
        <button
          id="nav-burger"
          @click="clickBurger"
          v-bind:class="{
            sticky: pastTop || pagename !== 'home',
            active: panelOpen,
          }"
        >
          <div
            id="nav-burger-menu"
            class="nav-burger-inner"
            v-bind:class="{ closecross: panelOpen }"
          >
            <div class="burger-bar burger-bar-1"></div>
            <div class="burger-bar burger-bar-2"></div>
            <div class="burger-bar burger-bar-3"></div>
          </div>
        </button>

        <div class="nav-panel" v-bind:class="{ active: panelOpen }">
          <div class="nav-panel-inner">
            <ul>
              <router-link :class="{ active: panelOpen }" to="/">
                <li
                  @click="clickNavPanel"
                  v-bind:class="{ active: pagename === 'home' }"
                >
                  <span v-html="nav.home"></span>
                </li>
              </router-link>
              <router-link :class="{ active: panelOpen }" to="/about/">
                <li
                  @click="clickNavPanel"
                  v-bind:class="{ active: pagename === 'about' }"
                >
                  <span v-html="nav.about"></span>
                </li>
              </router-link>
              <router-link :class="{ active: panelOpen }" to="/press/">
                <li
                  @click="clickNavPanel"
                  v-bind:class="{ active: pagename === 'press' }"
                >
                  <span v-html="nav.press"></span>
                </li>
              </router-link>
              <router-link :class="{ active: panelOpen }" to="/contact/">
                <li
                  @click="clickNavPanel"
                  v-bind:class="{ active: pagename === 'contact' }"
                >
                  <span v-html="nav.contact"></span>
                </li>
              </router-link>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div
      v-show="pagename === 'home'"
      ref="logo"
      class="logo-container"
      v-bind:class="{ sticky: pastTop }"
      :style="{ top: logoTop + 'px' }"
    >
      <img
        v-scroll-to="'#top'"
        class="logo"
        :src="'static/img/common/newlogo_black.png'"
      />
    </div>

    <div
      v-show="pagename !== 'home'"
      class="logo-container sticky logo-container-nofill"
    >
      <router-link to="/"
        ><img class="logo" :src="'static/img/common/newlogo_black.png'"
      /></router-link>
    </div>
  </nav>
</template>

<script>
import { commontools } from "../mixins/Styling";
import { nav } from "../../content.json";

import Vue from "vue"; // ✅ correct
import VueScrollTo from "vue-scrollto";

Vue.use(VueScrollTo, {
  container: "body",
  duration: 800,
  easing: "ease",
  offset: -100,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});
export default {
  name: "navbar",
  mixins: [commontools],
  data() {
    return {
      panelOpen: false,
      pagename: "",
      nav,
      opacityPercent: 0,
      pastTop: true,
      logoTop: 0,
    };
  },
  watch: {
    $route(to, from) {
      this.getNavParams();
    },
  },
  methods: {
    getNavParams() {
      if (this.pagename !== this.$route.name) this.panelOpen = false;
      this.pagename = this.$route.name;
    },
    clickBurger() {
      this.panelOpen = !this.panelOpen;
    },
    clickNavPanel() {
      this.panelOpen = false;
    },
    clickClose() {
      this.showMobileMenu = false;
      this.getNavParams();
    },
    handleNavScroll: function () {
      let scrolltop = window.scrollY;
      this.pastTop = window.innerHeight / 2 - scrolltop <= 26 ? true : false;
      this.opacityPercent = this.scrollPercent();
    },
    getLogoTop: function () {
      this.logoTop = window.innerHeight / 2;
    },
  },
  created() {
    window.addEventListener("scroll", this.handleNavScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleNavScroll);
  },
  mounted: function () {
    this.getNavParams();
    this.getLogoTop();
    this.handleNavScroll();
  },
  updated: function () {},
};
</script>

<style>
@import "../../static/css/vars.css";

nav {
  width: 100%;
  z-index: 999;
  position: relative;
}
.nav-top-row button {
  border: 0;
}
.logo-container {
  position: absolute;
  width: 100%;
  height: 60px;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  -webkit-transform: translate3d(-50%, -50%, 0);
  text-align: center;
  display: none;
}
.logo-container-trim {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 20px;
}
.logo-container-trim::before {
  content: "";
  position: absolute;
  width: 100%;
  left: 0;
  height: 100%;
  background-size: 100% auto;
  opacity: 0.1;

  background-image: url(/static/img/common/logo_blacksidedown.png);
}
.logo-container.sticky {
  display: block;
  position: fixed;
  top: 0px !important;
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  left: auto;
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
}
.logo-container-nofill {
  background-color: rgba(255, 255, 255, 0.8) !important;
}
.logo {
  position: absolute;
  top: 8px;
  width: 182px;
  height: 44px;
  background-size: 100%;
  background-repeat: no-repeat;
  transform: translate3d(-50%, 0, 0);
  -webkit-transform: translate3d(-50%, 0, 0);
}
.nav-panel {
  z-index: 1;
  position: fixed;
  width: 0;
  height: auto;
  right: 0;
  top: 100px;
  width: 160px;
  transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  -webkit-transform: translate3d(180px, 0px, 0) !important;
  transform: translate3d(180px, 0px, 0) !important;
  text-align: left;
  background-color: var(--main-color);
  padding: 0px 0 10px 20px;
}
.nav-panel.active {
  -webkit-transform: translate3d(0px, 0px, 0) !important;
  transform: translate3d(0px, 0px, 0) !important;
}
.nav-panel-inner {
  width: 100%;
  height: 100%;
}
.nav-panel-inner ul {
  width: 100%;
  position: relative;
}
.nav-panel-inner ul {
  padding: 0;
}
.nav-panel-inner li {
  font-family: "univers", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  letter-spacing: 0;
  font-weight: 700;

  list-style: none;
  font-size: 16px;
  position: relative;
  cursor: pointer;
  width: 100%;
  height: 30px;
  line-height: 30px;
  color: #ffffff;
  margin-top: 10px;
  transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
}
.nav-panel-inner a {
  text-decoration: none;
  visibility: hidden;
}
.nav-panel-inner a.active {
  visibility: visible;
}
.nav-panel-inner li:hover {
  -webkit-transform: translate3d(-10px, 0px, 0) !important;
  transform: translate3d(-10px, 0px, 0) !important;
}
.touch-device .nav-panel-inner li:active {
  opacity: 0.7;
  -webkit-transform: translate3d(-10px, 0px, 0) !important;
  transform: translate3d(-10px, 0px, 0) !important;
}
.nav-panel-inner span::before {
  content: "";
  position: absolute;
  width: 110%;
  height: 2px;
  background-color: #fff;
  border-radius: 1px;
  bottom: 4px;
  left: 0;
}
.nav-panel-inner li.active > span::before {
  bottom: 0px;
  height: 6px;
}

#nav-burger {
  position: absolute;
  right: 18px;
  top: 18px;
  z-index: 2;
  width: 34px;
  height: 34px;
  cursor: pointer;
  display: block;
  overflow: hidden;
  transition: background-color 0.3s ease-in-out;
  -webkit-transition: background-color 0.3s ease-in-out;
}
#nav-burger.sticky {
  position: fixed;
  top: 13px;
  right: 18px;
}
.touch-device #nav-burger.active {
  background-color: var(--main-color);
}
.no-touch-device #nav-burger:hover {
  background-color: var(--main-color);
}
.touch-device #nav-burger:active {
  background-color: var(--main-color);
}

.nav-burger-inner {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.burger-bar {
  width: 24px;
  height: 4px;
  left: 5px;
  top: 0;
  background-color: #000;
  position: absolute;
  transform-origin: 50% 50%;
  overflow: hidden;
  border-radius: 1px;
  transition: background-color 0.3s ease-in-out;
  -webkit-transition: background-color 0.3s ease-in-out;
}
.no-touch-device #nav-burger-menu:hover > .burger-bar {
  background-color: #fff;
}
#nav-burger-close {
  -webkit-transform: translate3d(40px, 0px, 0);
  transform: translate3d(40px, 0px, 0);
}
#nav-burger-menu.active,
#nav-burger-close.active {
  -webkit-transform: translate3d(0px, 0px, 0);
  transform: translate3d(0px, 0px, 0);
}

.menu-button-close.hidden {
  display: none;
}
.menu-button-bars.hidden {
  display: none;
}

#nav-burger-menu .burger-bar-1 {
  -webkit-transform: translate3d(0px, 7px, 0) rotate(0deg);
  transform: translate3d(0px, 7px, 0) rotate(0deg);
  animation: bar-1-menu 0.6s;
  -webkit-animation: bar-1-menu 0.6s;
  animation-fill-mode: forwards;
}
#nav-burger-menu .burger-bar-2 {
  -webkit-transform: translate3d(0px, 15px, 0) rotate(0);
  transform: translate3d(0px, 15px, 0) rotate(0);
  animation: bar-2-menu 0.6s;
  -webkit-animation: bar-2-menu 0.6s;
  animation-fill-mode: forwards;
}
#nav-burger-menu .burger-bar-3 {
  -webkit-transform: translate3d(0px, 27px, 0) rotate(0);
  transform: translate3d(0px, 27px, 0) rotate(0);
  animation: bar-3-menu 0.6s;
  -webkit-animation: bar-3-menu 0.6s;
  animation-fill-mode: forwards;
}

#nav-burger-menu.closecross .burger-bar-1 {
  animation: bar-1-close 0.6s;
  -webkit-animation: bar-1-close 0.6s;
  animation-fill-mode: forwards;
}
#nav-burger-menu.closecross .burger-bar-2 {
  animation: bar-2-close 0.6s;
  -webkit-animation: bar-2-close 0.6s;
  animation-fill-mode: forwards;
}
#nav-burger-menu.closecross .burger-bar-3 {
  animation: bar-3-close 0.6s;
  -webkit-animation: bar-3-close 0.6s;
  animation-fill-mode: forwards;
}
.touch-device #nav-burger.active .nav-burger-inner .burger-bar {
  background-color: #fff;
}

@keyframes bar-1-menu {
  0% {
    transform: translate3d(0px, 15px, 0) rotate(225deg);
    animation-timing-function: cubic-bezier(0.68, -0.6, 0.32, 1.6);
  }

  100% {
    transform: translate3d(0px, 7px, 0) rotate(0deg);
  }
}
@-webkit-keyframes bar-1-menu {
  0% {
    -webkit-transform: translate3d(0px, 15px, 0) rotate(225deg);
    -webkit-animation-timing-function: cubic-bezier(0.68, -0.6, 0.32, 1.6);
  }

  100% {
    -webkit-transform: translate3d(0px, 7px, 0) rotate(0deg);
  }
}

@keyframes bar-1-close {
  0% {
    transform: translate3d(0px, 7px, 0) rotate(0deg);
    animation-timing-function: cubic-bezier(0.68, -0.6, 0.32, 1.6);
  }

  100% {
    transform: translate3d(0px, 15px, 0) rotate(225deg);
  }
}
@-webkit-keyframes bar-1-close {
  0% {
    -webkit-transform: translate3d(0px, 7px, 0) rotate(0deg);
    -webkit-animation-timing-function: cubic-bezier(0.68, -0.6, 0.32, 1.6);
  }

  100% {
    -webkit-transform: translate3d(0px, 15px, 0) rotate(225deg);
  }
}

@keyframes bar-2-menu {
  0% {
    transform: translate3d(0px, 15px, 0) rotate(180deg);
    opacity: 0;
  }
  50% {
    transform: translate3d(0px, 15px, 0) rotate(180deg);
    opacity: 0;
  }
  100% {
    transform: translate3d(0px, 15px, 0) rotate(0deg);
    opacity: 1;
  }
}
@-webkit-keyframes bar-2-menu {
  0% {
    -webkit-transform: translate3d(0px, 15px, 0) rotate(180deg);
    opacity: 0;
  }
  50% {
    -webkit-transform: translate3d(0px, 15px, 0) rotate(180deg);
    opacity: 0;
  }
  100% {
    -webkit-transform: translate3d(0px, 15px, 0) rotate(0deg);
    opacity: 1;
  }
}

@keyframes bar-2-close {
  0% {
    transform: translate3d(0px, 15px, 0) rotate(0deg);
    opacity: 1;
  }

  100% {
    transform: translate3d(0px, 15px, 0) rotate(360deg);
    opacity: 0;
  }
}
@-webkit-keyframes bar-2-close {
  0% {
    -webkit-transform: translate3d(0px, 15px, 0) rotate(0deg);
    opacity: 1;
  }

  100% {
    -webkit-transform: translate3d(0px, 15px, 0) rotate(360deg);
    opacity: 0;
  }
}

@keyframes bar-3-menu {
  0% {
    transform: translate3d(0px, 15px, 0) rotate(-225deg);
    animation-timing-function: cubic-bezier(0.68, -0.6, 0.32, 1.6);
  }

  100% {
    transform: translate3d(0px, 23px, 0) rotate(0deg);
  }
}
@-webkit-keyframes bar-3-menu {
  0% {
    -webkit-transform: translate3d(0px, 15px, 0) rotate(-225deg);
    -webkit-animation-timing-function: cubic-bezier(0.68, -0.6, 0.32, 1.6);
  }

  100% {
    -webkit-transform: translate3d(0px, 23px, 0) rotate(0deg);
  }
}

@keyframes bar-3-close {
  0% {
    transform: translate3d(0px, 23px, 0) rotate(0deg);
    animation-timing-function: cubic-bezier(0.68, -0.6, 0.32, 1.6);
  }

  100% {
    transform: translate3d(0px, 15px, 0) rotate(-225deg);
  }
}
@-webkit-keyframes bar-3-close {
  0% {
    -webkit-transform: translate3d(0px, 23px, 0) rotate(0deg);
    -webkit-animation-timing-function: cubic-bezier(0.68, -0.6, 0.32, 1.6);
  }

  100% {
    -webkit-transform: translate3d(0px, 15px, 0) rotate(-225deg);
  }
}

@media (min-width: 576px) {
}
@media (min-width: 768px) {
  .logo-container {
    height: 60px;
  }
  .logo {
    top: 0px;
    width: 248px;
    height: 60px;
  }
  #nav-burger {
    right: 30px;
    top: 30px;
    width: 38px;
    height: 38px;
  }
  #nav-burger.sticky {
    position: fixed;
    right: 30px;
    top: 10px;
  }
  .burger-bar {
    width: 28px;
    height: 4px;
    left: 5px;
  }
  @-webkit-keyframes bar-1-menu {
    0% {
      -webkit-transform: translate3d(0px, 17px, 0) rotate(225deg);
      -webkit-animation-timing-function: cubic-bezier(0.68, -0.6, 0.32, 1.6);
    }
    100% {
      -webkit-transform: translate3d(0px, 7px, 0) rotate(0deg);
    }
  }
  @keyframes bar-1-menu {
    0% {
      transform: translate3d(0px, 17px, 0) rotate(225deg);
      animation-timing-function: cubic-bezier(0.68, -0.6, 0.32, 1.6);
    }
    100% {
      transform: translate3d(0px, 7px, 0) rotate(0deg);
    }
  }

  @-webkit-keyframes bar-1-close {
    0% {
      -webkit-transform: translate3d(0px, 7px, 0) rotate(0deg);
      -webkit-animation-timing-function: cubic-bezier(0.68, -0.6, 0.32, 1.6);
    }
    100% {
      -webkit-transform: translate3d(0px, 17px, 0) rotate(225deg);
    }
  }
  @keyframes bar-1-close {
    0% {
      transform: translate3d(0px, 7px, 0) rotate(0deg);
      animation-timing-function: cubic-bezier(0.68, -0.6, 0.32, 1.6);
    }
    100% {
      transform: translate3d(0px, 17px, 0) rotate(225deg);
    }
  }

  @-webkit-keyframes bar-2-menu {
    0% {
      -webkit-transform: translate3d(0px, 17px, 0) rotate(180deg);
      opacity: 0;
    }
    50% {
      -webkit-transform: translate3d(0px, 17px, 0) rotate(180deg);
      opacity: 0;
    }
    100% {
      -webkit-transform: translate3d(0px, 17px, 0) rotate(0deg);
      opacity: 1;
    }
  }
  @keyframes bar-2-menu {
    0% {
      transform: translate3d(0px, 17px, 0) rotate(180deg);
      opacity: 0;
    }
    50% {
      transform: translate3d(0px, 17px, 0) rotate(180deg);
      opacity: 0;
    }
    100% {
      transform: translate3d(0px, 17px, 0) rotate(0deg);
      opacity: 1;
    }
  }

  @-webkit-keyframes bar-2-close {
    0% {
      -webkit-transform: translate3d(0px, 17px, 0) rotate(0deg);
      opacity: 1;
    }
    100% {
      -webkit-transform: translate3d(0px, 17px, 0) rotate(360deg);
      opacity: 0;
    }
  }
  @keyframes bar-2-close {
    0% {
      transform: translate3d(0px, 17px, 0) rotate(0deg);
      opacity: 1;
    }
    100% {
      transform: translate3d(0px, 17px, 0) rotate(360deg);
      opacity: 0;
    }
  }

  @-webkit-keyframes bar-3-menu {
    0% {
      -webkit-transform: translate3d(0px, 17px, 0) rotate(-225deg);
      -webkit-animation-timing-function: cubic-bezier(0.68, -0.6, 0.32, 1.6);
    }
    100% {
      -webkit-transform: translate3d(0px, 27px, 0) rotate(0deg);
    }
  }
  @keyframes bar-3-menu {
    0% {
      transform: translate3d(0px, 17px, 0) rotate(-225deg);
      animation-timing-function: cubic-bezier(0.68, -0.6, 0.32, 1.6);
    }
    100% {
      transform: translate3d(0px, 27px, 0) rotate(0deg);
    }
  }

  @-webkit-keyframes bar-3-close {
    0% {
      -webkit-transform: translate3d(0px, 27px, 0) rotate(0deg);
      -webkit-animation-timing-function: cubic-bezier(0.68, -0.6, 0.32, 1.6);
    }
    100% {
      -webkit-transform: translate3d(0px, 17px, 0) rotate(-225deg);
    }
  }
  @keyframes bar-3-close {
    0% {
      transform: translate3d(0px, 27px, 0) rotate(0deg);
      animation-timing-function: cubic-bezier(0.68, -0.6, 0.32, 1.6);
    }
    100% {
      transform: translate3d(0px, 17px, 0) rotate(-225deg);
    }
  }
  .nav-panel {
    top: 100px;
  }
}
@media (min-width: 992px) {
  .logo {
    top: 5px;
    height: 50px;
  }
}
@media (min-width: 1200px) {
}
</style>
